export default function(baseURL, options) {
  options = options || {};

  const url = new URL(baseURL);

  for (const option in options) {
    url.searchParams.set(option, options[option]);
  }

  const f = url.searchParams.get("f");
  if ((f == "") || (f == null) || (f == "null")) {
    url.searchParams.delete("f");
  }

  return url;
}
